export default "__VITE_ASSET__BeaX0jwe__"